import React, { useRef } from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import {
  Menu,
  MenuAdd,
  MenuDelete,
  MenuEdit,
  MenuExport,
  MenuItem,
  MenuRecycle,
  MenuTableSettingToggle
} from '../../../../../shared/menu/menu'
import { useApiListGroup } from '../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { IconActivityLog, IconAdd, IconContent, IconGroup, IconUser } from '../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../shared/audit/use-audit-capabilities'
import { useRoleOrgGroup, useRoleOrgGroupUser, useRoleOrgNodeGroup } from '../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../shared/table-builder/table-columns'

export const GroupList = () => {
  const apiListGroup = useApiListGroup()

  const roleOrgGroup = useRoleOrgGroup()
  const caps = useAuditCapabilities()
  const roleOrgNodeGroup = useRoleOrgNodeGroup()
  const roleOrgGroupUser = useRoleOrgGroupUser()

  const handleReady = () => apiListGroup.get()
  const handleDestroyed = () => apiListGroup.init()

  const handleDelete = id => {
    apiListGroup.delete(id)
  }

  const tableRef = useRef()
  const handleExportCsv = () => tableRef.current.exportCsv('groups')
  const handleTableSettingToggle = () => tableRef.current.toggleSideBar()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add group" to="/org/group/list/add" show={roleOrgGroup.accessCreate} />
      <MenuExport onClick={handleExportCsv} show={roleOrgGroup.accessRead} />
      <MenuItem Icon={IconActivityLog} text="audit log" to="/org/audit-log?type=groups" show={caps.canAudit} />
      <MenuRecycle to="/org/group/list/recycle" show={roleOrgGroup.accessDelete} />
      <MenuTableSettingToggle onClick={handleTableSettingToggle} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconGroup} text="GROUPS">
        <CardFullHeightScrollY title="groups" HeaderMenu={HeaderMenu}>
          <TableAgClient
            ref={tableRef}
            apiList={apiListGroup}
            onReady={handleReady}
            onDestoryed={handleDestroyed}
            emptyState={{
              Icon: IconGroup,
              title: 'No groups yet',
              message: 'Create a group to give several people access to the same content.',
              action: { label: 'Add group', Icon: IconAdd, to: '/org/group/list/add', show: roleOrgGroup.accessCreate }
            }}>
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/org/group/list/edit/${row.id}`} show={roleOrgGroup.accessRead} />
                  <MenuItem Icon={IconContent} text="contents" to={`/org/group/list/edit/${row.id}/content`} show={roleOrgNodeGroup.accessRead} />
                  <MenuItem Icon={IconUser} text="users" to={`/org/group/list/edit/${row.id}/user`} show={roleOrgGroupUser.accessRead} />
                  <MenuDelete onClick={() => handleDelete(row.id)} show={roleOrgGroup.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
